var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"p-3 border-top text-right"},[_c('span',{staticClass:"text-muted"},[_vm._v("© iAMconnected "),_c('span',{domProps:{"textContent":_vm._s(_vm.date)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }